import { Outlet } from "react-router-dom";
import SystemAppSideBar from "../bars/SystemAppSideBar";
import {useAppLayoutStore} from "../../stores/appLayoutStore";

export default function SystemAppLayout() {
    // USed in index.js to frame screens that are considered
    // part of the application

    // PROPERTIES
    const hideSidebar = useAppLayoutStore((state) => state.hideSidebar);

    // BUILD
    return (
        <div className="w-full h-[100vh] flex ">
            {!hideSidebar && <SystemAppSideBar />}
            <Outlet />
        </div>
    );
}
